import React from "react";
import { MARQUEE_WORDS } from "../mock/data";

export default function Marquee() {
  const words = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div className="bg-baja-red py-4 overflow-hidden border-y border-black/20">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-white text-lg md:text-xl uppercase tracking-wide px-6">
              {w}
            </span>
            <span className="text-white/60 text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
